import React, { useEffect, useRef, useState, useMemo, forwardRef } from 'react';
// import { FloatingMenu } from './Helper/FloatingMenu';

import {
  EditorContainerRow,
  EditorToolsRow,
  CustomJobHeadingText,
  CustomEditorButtonDivStyle,
  CustomEditorButtonStyle,
  StyledToolsContainer,
  RerenderButtonContainer,
  DeleteConfirmationMessage,
  UndoRedoButtonContainer,
  CustomUndoRedoButtonStyle,
  GridTable,
  GridCell,
  Label
} from './styledComponents';
import { StyledTag } from '../../Content/styledComponents';
import moment from 'moment';
import {
  formatDate,
  getUserDateFormat,
  getUserTimeFormat
} from '../../../Utils/dateFormat';
import { updateDate } from '../../../Apis/Jobs';
import {
  SyncOutlined,
  CloudUploadOutlined,
  WarningOutlined,
  CopyOutlined
} from '@ant-design/icons';
import BrainEditorIcon from '../../../Assets/Icons/BrainEditorIcon';
import HeadingIcon from '../../../Assets/Icons/HeadingIcon';
import { notification, Tooltip, Spin, Select, DatePicker } from 'antd';
import SaveEditorIcon from '../../../Assets/Icons/SaveEditorIcon';
import { reconvertJob, GetWorkType, updateWorkType } from '../../../Apis/Jobs';
import QuillEditor from '../../CustomComponents/QuillEditor';
import { useSelector } from 'react-redux';
import RerenderIcon from '../../../Assets/Icons/RerenderIcon';
import ConfirmationModal from '../ConfirmationModal';
import Spinner from '../Spinner';
import WarningIcon from '../../../Assets/Icons/WarningIcon';
import UndoIcon from '../../../Assets/Icons/UndoIcon';
import RedoIcon from '../../../Assets/Icons/RedoIcon';

const NewEditorComponent = forwardRef((props, ref) => {
  const editorRef = ref || useRef(null);
  const [selectedWorkType, setSelectedWorkType] = useState();
  const [refreshKey, setRefreshKey] = useState(0);
  const [isHeading, setIsHeading] = useState(false);
  const [theme] = useSelector(state => [state.themeReducer]);
  const [revertJobModalVisible, setRevertJobModalVisible] = useState(false);

  const [workTypeOptions, setWorkTypeOptions] = useState([]);
  const [workTypeLoader, setWorkTypeLoader] = useState(false);
  // const [workType, setWorkType] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const dateOfVisitValue = props.demographicsData?.find(
    d => d?.key === 'DATE OF VISIT'
  )?.value;

  const defaultMoment = useMemo(() => {
    if (!dateOfVisitValue) return null;
    const parsed = moment(dateOfVisitValue);
    return parsed.isValid() ? parsed : null;
  }, [dateOfVisitValue]);

  const user = JSON.parse(localStorage.getItem('user'));
  function processValue(value) {
    let content = value;

    // Split by <br> tags and wrap each part in <p> tags (this format works!)
    const parts = content.split(/<br\s*\/?>/gi);

    if (parts.length > 1) {
      // Convert br tags to separate paragraphs
      content = parts
        .map(part => {
          part = part.trim();
          // Remove existing <p> tags to avoid nesting
          part = part.replace(/<\/?p>/gi, '');
          // Return as paragraph
          return part ? `<p>${part}</p>` : '<p><br></p>';
        })
        .join('');
    }

    return content;
  }
  const disabledDate = current => {
    return current && current > moment().endOf('day');
  };
  const disabledTime = current => {
    if (current && current.isSame(moment(), 'day')) {
      const now = moment();
      const currentHour = now.hour();
      const currentMinute = now.minute();
      return {
        disabledHours: () =>
          Array.from({ length: 24 }, (_, i) => i).filter(h => h > currentHour),
        disabledMinutes: selectedHour =>
          selectedHour === currentHour
            ? Array.from({ length: 60 }, (_, i) => i).filter(
                m => m > currentMinute
              )
            : []
      };
    }
    return {};
  };
  const revertJob = () => {
    props.setEditorLoading(true);
    reconvertJob(props.jobId)
      .then(response => {
        if (response.data.success) {
          for (let i = 0; i < response.data.result.length; i++) {
            const resultItem = response.data.result[i];
            for (let j = 0; j < resultItem.sections.length; j++) {
              const section = resultItem.sections[j];
              for (let k = 0; k < section.content.length; k++) {
                const contentItem = section.content[k];
                if (contentItem.type === 'Text') {
                  response.data.result[i].sections[j].content[k].value =
                    processValue(contentItem.value);
                }
              }
            }
          }

          props.setActiveSection(
            response.data.result[0].sections &&
              response.data.result[0].sections.length > 0 &&
              response.data.result[0].sections[0].id
          );

          props.setLastUpdateTime(response.data.result[0].lastUpdatedTime);
          props.setEditorLoading(false);

          setRevertJobModalVisible(false);
        } else {
          notification['error']({
            message: 'Section Fetch Failed',
            description: response.data.message
          });
          props.setEditorLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        props.setEditorLoading(false);
      });
  };

  useEffect(() => {
    if (props.saveStatus === 'Saved') {
      setTimeout(() => {
        props.setSaveStatus(null);
      }, 1000);
    }
    // eslint-disable-next-line
  }, [props.saveStatus, props.loading]);
  const getOptionObjectsFromArray = options => {
    if (!options) return [];
    let newObj = [];
    return options.map(item =>
      Object.assign(...newObj, { value: item, label: item })
    );
  };
  const workTypeFetchedRef = useRef(false);
  useEffect(() => {
    if (!props.jobId || workTypeFetchedRef.current) return;
    workTypeFetchedRef.current = true;

    GetWorkType(props.jobId).then(res => {
      const options = getOptionObjectsFromArray(res.data.workTypes);
      setWorkTypeOptions(options);
    });
  }, [props.jobId]);

  // Separate effect to set work type when demographicsData becomes available
  useEffect(() => {
    if (!props.demographicsData || workTypeOptions.length === 0) return;

    let work = props.demographicsData?.filter(
      data => data?.key === 'WORK TYPE'
    )[0]?.value;
    let t = workTypeOptions.filter(data => data.value === work)?.[0];
    if (t) {
      props.setWorkType(t);
    }
  }, [props.demographicsData, workTypeOptions]);
  const handleChange = value => {
    setSelectedWorkType(value);
    props.setWorkType(value);
    updateWorkType(props.jobId, user.sessionId, value).then(response => {
      if (response.data.success) {
        props.setRefetchDemographics(true);
        props.setInferenceActive(false);
      } else {
        notification['error']({
          message: 'Save Failed',
          description: response.data.message
        });
        props.setRefetchDemographics(true);
        props.setInferenceActive(false);
      }
    });
    setSelectedWorkType(value);

    showModal();
  };
  const handleSearch = searchValue => {
    // Perform search-related actions if needed
  };

  return (
    <>
      <CustomJobHeadingText color={'#47A4EA'}></CustomJobHeadingText>
      <EditorContainerRow>
        <GridTable>
          <GridCell>
            <Label>Name</Label>
            <div style={{ fontWeight: 'bold', color: '#47A4EA' }}>
              {props.demographicsData?.find(d => d?.key === 'NAME')?.value ||
                '-'}
            </div>
          </GridCell>

          <GridCell>
            <Label>Room/Bed</Label>
            <div>
              {props.demographicsData?.find(d => d?.key === 'bedId')?.value ||
                props.tabDataPatient?.patientdetails?.[0]?.bedId ||
                '-'}
            </div>
          </GridCell>

          <GridCell>
            <Label>Date of Admission</Label>
            <div>
              {formatDate(
                props.demographicsData?.find(d => d?.key === 'admissionDate')
                  ?.value ||
                  props.tabDataPatient?.patientdetails?.[0]?.admissionDate,
                '-'
              )}
            </div>
          </GridCell>
          <GridCell>
            <Label>Gender</Label>
            {props.demographicsData?.find(d => d?.key === 'GENDER')?.value ||
              '-'}
          </GridCell>
          <GridCell>
            <Label>DOB</Label>
            {formatDate(
              props.demographicsData?.find(d => d?.key === 'DATE OF BIRTH')
                ?.value,
              '-'
            )}
          </GridCell>
          <GridCell>
            <Label>Note Author</Label>
            <div>{props.printInfoData[0]?.author || '-'}</div>
          </GridCell>

          <GridCell>
            <Label>Facility</Label>
            <div>
              {props.printInfoData[0]?.facility?.facilityName
                ? props.printInfoData[0].facility.facilityName.slice(0, 20) +
                  (props.printInfoData[0].facility.facilityName.length > 20
                    ? '...'
                    : '')
                : '-'}
            </div>
          </GridCell>

          <GridCell>
            <Label>Date of Encounter</Label>
            <DatePicker
              key={`${dateOfVisitValue}-${refreshKey}`}
              disabledDate={disabledDate}
              disabledTime={disabledTime}
              format={`${getUserDateFormat()} ${getUserTimeFormat()}`}
              bordered={false}
              allowClear={false}
              defaultValue={defaultMoment}
              showTime={{
                format: getUserTimeFormat(),
                use12Hours: getUserTimeFormat().includes('A')
              }}
              onChange={(date, dateString) => {
                if (!date) return;
                const dateConvertion = moment(
                  dateString,
                  `${getUserDateFormat()} ${getUserTimeFormat()}`
                ).toISOString();
                if (!dateConvertion) return;
                if (moment(dateConvertion).isAfter(moment())) {
                  notification.warning({
                    message:
                      'Future date/time is not allowed for Date of Encounter'
                  });
                  setRefreshKey(prev => prev + 1);
                  return;
                }
                updateDate(props.jobId, dateConvertion).then(response => {
                  if (response.data.success) {
                    notification.success({
                      message: 'Date of encounter updated'
                    });
                    if (props.updateEncounterDate) {
                      props.updateEncounterDate(dateConvertion);
                    }
                    if (editorRef.current) {
                      editorRef.current.saveData();
                    }
                  } else {
                    notification['error']({
                      message: 'Save Failed',
                      description: response.data.message
                    });
                    setRefreshKey(prev => prev + 1);
                  }
                });
              }}
            />
          </GridCell>

          <GridCell>
            <Label>Template</Label>
            <div>{props.dectationTemplates || '-'}</div>
          </GridCell>
          <GridCell>
            <Label>Work Type</Label>
            <div>
              {workTypeLoader ? (
                <Spin />
              ) : (
                <Select
                  key={refreshKey}
                  value={props.workType}
                  style={{ width: '100%' }}
                  bordered={false}
                  showSearch
                  onSearch={handleSearch}
                  onChange={handleChange}
                  options={workTypeOptions}
                  className='custom-dropdown'
                />
              )}
            </div>
          </GridCell>
        </GridTable>

        <EditorToolsRow>
          {/* <CustomHeadingText color={theme['@table-text-color']}>
            Audio Name 12365478987452336
          </CustomHeadingText> */}
          <CustomEditorButtonDivStyle>
            <StyledToolsContainer>
              {/* <Tooltip placement='bottom' title='Inference Engine'>
                <CustomEditorButtonStyle
                  icon={
                    <BrainEditorIcon
                      fill={
                        props.inferenceActive &&
                        !props.newInferenceActive &&
                        theme['@primary-color']
                      }
                    />
                  }
                  onClick={() => {
                    props.setInferenceActive(
                      !(props.inferenceActive && !props.newInferenceActive)
                    );
                    props.setNewInferenceActive(
                      props.inferenceActive ? false : props.newInferenceActive
                    );
                  }}
                />
              </Tooltip> */}

              <Tooltip placement='bottom' title='Save'>
                <CustomEditorButtonStyle
                  icon={
                    <SaveEditorIcon
                      fill={props.viewOnly ? '' : theme['@primary-color']}
                    />
                  }
                  onClick={() => {
                    editorRef.current.saveData();
                  }}
                  hidden={props?.viewOnly}
                />
              </Tooltip>
              <Tooltip placement='bottom' title='Copy Content'>
                <CustomEditorButtonStyle
                  icon={
                    <CopyOutlined
                      style={{
                        color: theme['@primary-color'],
                        fontSize: '16px'
                      }}
                    />
                  }
                  onClick={() => {
                    const text = editorRef.current.getContentText();
                    navigator.clipboard.writeText(text).then(() => {
                      notification.success({
                        message: 'Copied',
                        description: 'Content copied to clipboard',
                        duration: 2
                      });
                    });
                  }}
                />
              </Tooltip>
              {/* <Tooltip placement='bottom' title='Heading Tool'>
                <CustomEditorButtonStyle
                  icon={
                    <HeadingIcon
                      fill={
                        isHeading || props.viewOnly
                          ? ''
                          : theme['@primary-color']
                      }
                    />
                  }
                  onClick={event => {
                    event.preventDefault();
                    editorRef.current.headingHandler();
                  }}
                  hidden={props?.viewOnly}
                />
              </Tooltip> */}
              {props.saveStatus && (
                <StyledTag
                  icon={
                    props.saveStatus === 'Saved' ? (
                      <CloudUploadOutlined />
                    ) : props.saveStatus === 'Saving' ? (
                      <SyncOutlined spin />
                    ) : props.saveStatus === 'You are Offline' ? (
                      <WarningOutlined />
                    ) : null
                  }
                >
                  {props.saveStatus}
                </StyledTag>
              )}
            </StyledToolsContainer>
            <UndoRedoButtonContainer>
              <Tooltip placement='bottom' title='Undo'>
                <CustomUndoRedoButtonStyle
                  icon={<UndoIcon />}
                  onClick={() => {
                    editorRef.current.handleUndo();
                  }}
                  hidden={props?.viewOnly}
                />
              </Tooltip>
              <Tooltip placement='bottom' title='Redo'>
                <CustomUndoRedoButtonStyle
                  icon={<RedoIcon />}
                  onClick={() => {
                    editorRef.current.handleRedo();
                  }}
                  hidden={props?.viewOnly}
                />
              </Tooltip>
            </UndoRedoButtonContainer>
            <RerenderButtonContainer>
              <Tooltip placement='bottom' title='Reconvert'>
                <CustomEditorButtonStyle
                  icon={<RerenderIcon />}
                  onClick={() => {
                    setRevertJobModalVisible(true);
                  }}
                  hidden={props?.viewOnly}
                />
              </Tooltip>
            </RerenderButtonContainer>
          </CustomEditorButtonDivStyle>
        </EditorToolsRow>
        {props.loading ? (
          <Spinner height='calc(100vh - 400px)' />
        ) : (
          <QuillEditor
            setCptCodesLoader={props.setCptCodesLoader}
            // setIgnore={props.setIgnore}
            deleteModalVisible={props.deleteModalVisible}
            setDeleteModalVisible={props.setDeleteModalVisible}
            cptCodesLoader={props.cptCodesLoader}
            setEditedSections={props.setEditedSections}
            setParagraphs={props.setParagraphs}
            setCptCodes={props.setCptCodes}
            sections={props.sections}
            headings={props.headings}
            jobName={props.jobName}
            jobId={props.jobId}
            lastUpdateTime={props.lastUpdateTime}
            setLastUpdateTime={props.setLastUpdateTime}
            ref={editorRef}
            saveStatus={props.saveStatus}
            setSaveStatus={props.setSaveStatus}
            isHeading={isHeading}
            setIsHeading={setIsHeading}
            theme={theme}
            audioRef={props.audioRef}
            activeSection={props.activeSection}
            setActiveSection={props.setActiveSection}
            fetchContents={props.fetchContents}
            loading={props.loading}
            setEditorLoading={props.setEditorLoading}
            deleteSectionHandler={props.deleteSectionHandler}
            deleteSectionFromEditor={props.deleteSectionFromEditor}
            changeStatus={props.changeStatus}
            activeSectionContent={props.activeSectionContent}
            setActiveSectionContent={props.setActiveSectionContent}
            viewOnly={props?.viewOnly}
            localSectionIdMap={props.localSectionIdMap}
            tabDataPatient={props.tabDataPatient}
            printInfoData={props.printInfoData}
            demographicsData={props.demographicsData}
            selectionVersion={props.selectionVersion}
            patientDataSelection={props.patientDataSelection}
            patientData={props.patientData}
          />
        )}
      </EditorContainerRow>

      <ConfirmationModal
        visible={revertJobModalVisible}
        onOk={() => revertJob()}
        onCancel={() => {
          setRevertJobModalVisible(false);
        }}
        loading={props.loading}
        confirmation={true}
        antdModalProps={{ closable: false }}
      >
        <WarningIcon />
        <DeleteConfirmationMessage>
          Are you sure you want to reconvert the dictation?
        </DeleteConfirmationMessage>
      </ConfirmationModal>
    </>
  );
});

export default NewEditorComponent;
